import { IBFContext } from 'interfaces/bienesFiscales/IBFContext';
import { createContext } from 'react';

export const BFContext = createContext<IBFContext>({} as IBFContext);
